import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ title, description, icon, iconColor, path }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <button
      onClick={handleClick}
      className="w-full bg-card rounded-xl p-4 md:p-6 border border-border shadow-warm-sm hover:shadow-warm-md transition-smooth text-left group"
    >
      <div className="flex items-start gap-4">
        <div 
          className="w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-smooth"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="text-base md:text-lg font-heading font-semibold text-card-foreground mb-1 group-hover:text-primary transition-smooth">
            {title}
          </h4>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>

        <Icon 
          name="ChevronRight" 
          size={20} 
          color="var(--color-muted-foreground)"
          className="flex-shrink-0 group-hover:translate-x-1 transition-smooth"
        />
      </div>
    </button>
  );
};

export default QuickActionCard;